import React, { useEffect, useState } from "react";
import { Col, Form } from "react-bootstrap";
import reportCardApi from "./reportCardApi";

/**
 * Class + Section dropdowns (as two <Col>s).
 * value = { class_id, section_id }, onChange(newValue)
 */
const ClassSectionPicker = ({ value, onChange, md = 3 }) => {
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);

  useEffect(() => {
    reportCardApi.activeClasses().then(setClasses).catch(() => setClasses([]));
  }, []);

  useEffect(() => {
    if (!value.class_id) return setSections([]);
    reportCardApi.sections(value.class_id).then((list) => {
      setSections(list);
      // auto-pick when the class has only one section
      if (list.length === 1 && !value.section_id) onChange({ ...value, section_id: list[0].id });
    }).catch(() => setSections([]));
    // eslint-disable-next-line
  }, [value.class_id]);

  return (
    <>
      <Col md={md}>
        <Form.Label className="form-view-label">Class</Form.Label>
        <Form.Select value={value.class_id || ""} onChange={(e) => onChange({ class_id: e.target.value, section_id: "" })}>
          <option value="">-- Select Class --</option>
          {classes.map((c) => <option key={c.id} value={c.id}>{c.class_name || c.classname}</option>)}
        </Form.Select>
      </Col>
      <Col md={md}>
        <Form.Label className="form-view-label">Section</Form.Label>
        <Form.Select value={value.section_id || ""} disabled={!value.class_id} onChange={(e) => onChange({ ...value, section_id: e.target.value })}>
          <option value="">-- Select Section --</option>
          {sections.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </Form.Select>
      </Col>
    </>
  );
};

export default ClassSectionPicker;
